import * as modal from "../util/modal.ts";

import {FilerTreeCache} from "../server/objects/FilerBeans.js"

type PickFolderOptions = {
  title:string,
  value?:string,
  reject?:string,
  direct:boolean
}

export async function pickFolder(options :PickFolderOptions){
  await FilerTreeCache.need();
  var metaId = await modal.askAsPromiseTpl(await import('./folderpicker.mustache'),{
    title:options.title,
    value:options.value,
    reject:options.reject,
    direct:options.direct,
    button:FilerTreeCache.getRoot().withTree().folders.map(folder=>{
      return folder.withTree()
    })
  });
  return FilerTreeCache.get(metaId);
}

/**
 * @param {{
* title:string,
* value:string,
* reject:string,
* }} options 
*/
export async function pickFile(options){
  await FilerTreeCache.need();
  var 
    folder = await pickFolder({title:options.title,direct:true});
  if(!folder) return;  
  var  
    fileResponse = await modal.askAsPromiseTpl(await import('./filepicker.mustache'),{
      folderName:folder.name,
      button:folder.withTree().content
    });
  
  if(fileResponse==='back'){
    return pickFile(options);
  }  
  return FilerTreeCache.get(fileResponse);  
}


